import { Container } from "@material-ui/core";
import Logo from "../../../../../assets/images/logo.png";
import TextLogo from "../../../../../assets/images/text-logo.png";
import LanguageSwitcher from "../../../components/LanguageSwitcher";
import MenuIcon from '@material-ui/icons/Menu';
import PersonIcon from '@material-ui/icons/Person';
import "./index.css";
import User from "./User";
import { useState, useEffect } from "react";
import CustomBreadcrumbs from "./Breadcrumbs";
import { shallowEqual, useSelector } from "react-redux";
import organizationApi from "../../../../api/organizationApi";
import { connect } from "react-redux";
import { setUserOrganization } from "../../../../redux/actions"
import { useLanguage } from "../../../hooks";
import { USER_ROLE_ID } from "../../../constants/users";

const Header = (props) => {
  const {
    active,
    menuClick,
    setMenuClick,
    breadcrumbs,
    title,
  } = props;
  const [menuActive, setMenuActive] = useState(false);
  const [language] = useLanguage();
  const { token, user, userOrganization } = useSelector(
    ({ user }) => ({
      token: user.token,
      user: user.user,
      userOrganization: user.userOrganization
    }),
    shallowEqual
  );
  useEffect(() => {
    const getOrganization = async () => {
      try {
        const id = user.organizationId;
        const res = await organizationApi.getOrganization(id, token);
        if (res.success) {
          props.setUserOrganization({
            ...res.data,
            url_logo: res.data.url_logo ?
              `${process.env.REACT_APP_API_URL}/${res.data.url_logo}` :
              null
          });
        }
      } catch (error) {
        console.log(error);
      }
    }

    getOrganization();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <>
      <div className={`main-header ${!active ? "main-header-inactive" : ""} ${user.roleId === USER_ROLE_ID.CONTENT_ROLE ? "non-left" : ""}`}>
        <Container maxWidth={false} className="container">
          <div className="logo">
            <img src={(userOrganization && userOrganization.url_logo) || Logo} alt="logo" />
          </div>
          <div className="actions">
            <LanguageSwitcher />
            <User />
          </div>
        </Container>
        <div className="breadcrumbs-wrapper">
          <CustomBreadcrumbs
            title={title}
            items={breadcrumbs}
          />
        </div>
      </div>
      <div className="mobile-header">
        <Container maxWidth={false} className="container">
          <div className="logo organization-name" >
            {(userOrganization && userOrganization.name) ? (language === "en" ? userOrganization.name : userOrganization.nameVi) :
              <img src={TextLogo} alt="logo" />
            }
          </div>
          <div className="actions">
            <div className="menu" onClick={() => setMenuClick(!menuClick)}>
              <MenuIcon className={`${menuClick ? "active-icon" : ""}`} />
            </div>
            <div className="user" onClick={() => setMenuActive(!menuActive)}>
              <PersonIcon className={`${menuActive ? "active-icon" : ""}`} />
            </div>
          </div>
        </Container>
        <div className="breadcrumbs-wrapper">
          <CustomBreadcrumbs
            title={title}
            items={breadcrumbs}
          />
        </div>
        <div className={`menu-hidden ${menuActive ? "menu-active" : ""}`}>
          <Container className="container">
            <LanguageSwitcher />
            <User />
          </Container>
        </div>
      </div>
    </>
  );
};

export default connect(null, { setUserOrganization })(Header);


